import axios from "axios";
import React, { useState } from "react";
import Header from "../Helper/Header";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import NewFooter from "../Helper/NewFooter";
import HiringBanner from "../HiringBanner/HiringBanner";

const ContactForm = ({ showHeader = true, showFooter = true, showcareer = true }) => {
  const [message, setMessage] = useState({ status: 0, value: "" });
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    email: "",
    organization: "",
  });

  async function submitForm() {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      
      const payload = {
        sheet_id: "1voJ7ozFGYqE-mbelORkiXGmhB-97E-Bn6Qvl0Px-3bU",
        sheet_name: "Contact Form",
        data: formData
      };

      await axios.post(
        "https://5l2ipjsrylacx3h7cxu4sqob6y0lnfsv.lambda-url.us-east-1.on.aws", 
        payload, 
        { headers }
      );
      
      setMessage({ status: 1, value: "Message sent successfully." });
      setTimeout(() => {
        setFormData({
          name: "",
          designation: "",
          email: "",
          organization: "",
        });
      }, 786);
    } catch (error) {
      setMessage({
        status: 0,
        value: "There was a problem sending your request, please try again later.",
      });
      console.error("Error making post request:", error.message);
    }
  }

  return (
    <>
      {showHeader && <Header />}
      <Container className="contact-form-container">
        <Row>
          <Col xs={12} lg={6} className="text-column">
            <h1 className="form-heading">
              Let's Collaborate to build a Sustainable Future.
            </h1>
          </Col>
          <Col xs={12} lg={6} className="form-column">
            <h2>Contact Us:</h2>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                submitForm();
              }}
            >
              <Form.Group controlId="name">
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  required
                  className="form-style"
                />
              </Form.Group>
              <Form.Group controlId="designation">
                <Form.Label>Your Designation*</Form.Label>
                <Form.Control
                  type="text"
                  name="designation"
                  value={formData.designation}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  required
                  className="form-style"
                />
              </Form.Group>
              <Form.Group controlId="email">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  required
                  className="form-style"
                />
              </Form.Group>
              <Form.Group controlId="organization">
                <Form.Label>Organization*</Form.Label>
                <Form.Control
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                  required
                  className="form-style"
                />
              </Form.Group>
              {message.value && message.value !== "" && (
                <Alert
                  variant={message.status === 1 ? "success" : "danger"}
                  className="mt-3"
                >
                  {message.value}
                </Alert>
              )}
              <div className="d-flex justify-content-center align-items-center">
                <Button type="submit" className="w-50">
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      {showcareer && <HiringBanner />}
      {showFooter && <NewFooter />}
    </>
  );
};

export default ContactForm;